import type { BlockUIDesignTokens } from '@primeuix/themes/aura/blockui';

export default {
  root: {
    borderRadius: '{content.border.radius}',
  },
} satisfies BlockUIDesignTokens;
